module.exports = __webpack_public_path__ + "fonts/iconfont.0a6ed252.ttf";